import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-callc_close",
  "use": "icon-callc_close-usage",
  "viewBox": "0 0 36 36",
  "content": "<symbol viewBox=\"0 0 36 36\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-callc_close\"><clipPath id=\"icon-callc_close_a\"><path d=\"m0 0h36v36h-36z\" /></clipPath><g clip-path=\"url(#icon-callc_close_a)\" fill=\"#fff\"><path d=\"m18 34c-8.822 0-16-7.177-16-16 0-8.822 7.178-16 16-16s16 7.178 16 16c0 8.823-7.178 16-16 16zm0-30c-7.72 0-14 6.28-14 14s6.28 14 14 14 14-6.28 14-14-6.28-14-14-14z\" /><path d=\"m22.5 23.5c-.256 0-.512-.098-.707-.293l-9-9c-.391-.391-.391-1.023 0-1.414s1.023-.391 1.414 0l9 9c.391.391.391 1.023 0 1.414-.195.196-.451.293-.707.293z\" /><path d=\"m13.5 23.5c-.256 0-.512-.098-.707-.293-.391-.391-.391-1.023 0-1.414l9-9c.391-.391 1.023-.391 1.414 0s.391 1.023 0 1.414l-9 9c-.195.196-.451.293-.707.293z\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/callc_close.svg
// module id = vJkb
// module chunks = 87